// @flow

import type { State } from "@store/reducers";
import type { WellbeingProvider, SystemMessagesLogin } from "@modules/shared/reducer/types";

export const getWellbeingProviders = (state: State): WellbeingProvider =>
  state.shared.home.wellbeingProviders;

export const getSystemMessagesLoginData = (state: State): SystemMessagesLogin | null =>
  state.shared.home.login;

export type ReleaseNote = {
  id: number,
  name: string,
  file: null,
  byteSize: number,
  createdAt: string,
  updatedAt: string,
  isArchived: boolean,
  version: string,
};

export const getSystemMessagesReleaseNote = (state: State): ReleaseNote | null =>
  state.shared.home.releaseNote;

export const isHomeLoading = (state: State): boolean => !!state.shared.home.requestsInProgress;
